import useAuth from './useAuth'

export default function useDismissedActionRequests(): string[] {
  /**
   * The current user.
   */
  const { currentUser } = useAuth()

  // Get the dismissed action requests from the local storage.
  const dismissedActionRequests: Record<string, string[]> = JSON.parse(
    localStorage.getItem('dismissedActionRequests') ?? '{}'
  ) as Record<string, string[]>

  // Return the dismissed action requests for the current user.
  return currentUser && currentUser.id in dismissedActionRequests
    ? dismissedActionRequests[currentUser.id]
    : []
}
